import { Injectable } from "@angular/core";
import { UserService } from "../../../services/userService";
import { User } from "../../../objects/users/user";
import { BaseResponse } from "../../../objects/common/baseResponse";
/**
 * Created by alex.y on 10/25/2017.
 */

@Injectable()
export class AllUserResolver {

    constructor(private userService: UserService) {
    }

    public resolve(): Promise<BaseResponse<Array<User>>> {
        return this.userService.getAll().then(result => {
            return result.Data;
        }).catch(err => {
            return null;
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/reports/totalAmount/allUser.resolver.ts